import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import api from "@/api";
import { useClientStore } from "@/stores/clients";
import { useEmployeeStore } from "@/stores/employees";
import { useDocumentsStore } from "@/stores/documents";
import { useProjectStore } from "@/stores/projects";
import { useCompanyStore } from "@/stores/company";
import { onMounted, ref } from "vue";
import { useUiStore } from "@/stores/ui";


export default /*#__PURE__*/_defineComponent({
  __name: 'Bootstrap',
  setup(__props) {

const clientsStore = useClientStore();
const employeesStore = useEmployeeStore();
const documentsStore = useDocumentsStore();
const projectsStore = useProjectStore();
const companyStore = useCompanyStore();
const uiStore = useUiStore();

const loaded = ref(false);

const bootstrap = () => {
    api.read().then((response: any) => {
        console.log(response);
        clientsStore.list = response.clients;
        employeesStore.list = response.users;
        documentsStore.list = response.documents;
        projectsStore.list = response.projects;
        companyStore.company = response.company;
        uiStore.user = response.user;
        loaded.value = true;
    });
};

onMounted(() => {
    bootstrap();
});

return (_ctx: any,_cache: any) => {
  return (loaded.value)
    ? _renderSlot(_ctx.$slots, "default", { key: 0 })
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createTextVNode(" ... ")
      ], 64))
}
}

})